var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"right-link mr-4",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.init_fulllscreen()}}},[_c('i',{staticClass:"ti ti-fullscreen"})])}
var staticRenderFns = []

export { render, staticRenderFns }